import { DatabricksParameter } from 'app/model/pipeline/databricks-parameter';
import { Owned } from 'app/model/base/named';
import { IAttribute } from 'app/model/base/annotation';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { ParameterConfig } from './parameter-config';

export function databricksParameterToResource(parameters: DatabricksParameter[] | undefined): string[] | undefined {
    return parameters ? parameters.map((parameter) => toResource(parameter, DatabricksParameter.VALUE)) : undefined;
}

export function databricksParameterToModel(parameters: string[] | undefined, owner: Owned): DatabricksParameter[] {
    const result: DatabricksParameter[] = [];
    if (parameters) {
        parameters.forEach((parameter) => {
            const databricksParameter = Owned.create<DatabricksParameter>(DatabricksParameter.MODEL, owner);
            toModel(databricksParameter, DatabricksParameter.VALUE, parameter);
            result.push(databricksParameter);
        });
    }
    return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toResource(object: {}, attribute: IAttribute): any {
    const value = attribute.templateValue(object);
    return value !== undefined ? value : attribute.value(object);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toModel(object: {}, attribute: IAttribute, value: any): void {
    if (value == null) {
        return;
    }
    if (typeof value === 'string' && isLogicAppExpression(value)) {
        attribute.setTemplateValue(object, value);
    } else {
        attribute.setValue(object, value);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function databricksInitScriptsToArrayModel(initscripts: any, owner: Owned): ParameterConfig[] | undefined {
    if (initscripts != null && Array.isArray(initscripts)) {
        const result: ParameterConfig[] = [];
        for (const initscript of initscripts) {
            if (typeof initscript === 'string' && initscript?.startsWith('dbfs:/')) {
                const paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, owner);
                paramConfig.name = 'Dbfs';
                ValueAdapter.toModel(paramConfig, ParameterConfig.VALUE, initscript);
                result.push(paramConfig);
            } else if (typeof initscript === 'string' && initscript?.startsWith('abfss:/')) {
                const paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, owner);
                paramConfig.name = 'Abfss';
                ValueAdapter.toModel(paramConfig, ParameterConfig.VALUE, initscript);
                result.push(paramConfig);
            } else if (typeof initscript === 'string' && initscript?.startsWith('/Volumes/')) {
                const paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, owner);
                paramConfig.name = 'Volumes';
                ValueAdapter.toModel(paramConfig, ParameterConfig.VALUE, initscript);
                result.push(paramConfig);
            } else if (typeof initscript === 'string' && initscript?.startsWith('/')) {
                const paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, owner);
                paramConfig.name = 'Workspace';
                ValueAdapter.toModel(paramConfig, ParameterConfig.VALUE, initscript);
                result.push(paramConfig);
            } else {
                const paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, owner);
                paramConfig.name = '';
                ValueAdapter.toModel(paramConfig, ParameterConfig.VALUE, initscript);
                result.push(paramConfig);
            }
        }
        return result;
    } else {
        return [];
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function databricksInitScriptsToResource(initscripts: DatabricksParameter[] | undefined): any[] {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any[] = [];
    if (initscripts) {
        const initscriptValues = Object.values(initscripts);
        initscriptValues.forEach((initscript) => {
            if (ParameterConfig.VALUE.templateValue(initscript) !== null) {
                const initscriptpath = ValueAdapter.toResource(initscript, ParameterConfig.VALUE);
                result.push(initscriptpath);
            }
            else {
                const initscriptpath = ValueAdapter.toResource(initscript, DatabricksParameter.VALUE);
                result.push(initscriptpath);
            }
        });
    }
    return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function databricksInitScriptsToModel(initscripts: any | undefined, owner: Owned): DatabricksParameter[] {
    const result: DatabricksParameter[] = [];
    if (initscripts && Array.isArray(initscripts)) {
        initscripts.forEach((initscript) => {
            const databricksParameter = Owned.create<DatabricksParameter>(DatabricksParameter.MODEL, owner);
            ValueAdapter.toModel(databricksParameter, DatabricksParameter.VALUE, initscript);
            result.push(databricksParameter);
        });
    }
    return result;
}
